<template>
  <div class="w-full flex gap-x-1.5">
    <div
      v-for="type in types"
      :key="type"
      class="w-1/2"
      :class="getOuterClasses(type)"
    >
      <div
        class="h-[250px] rounded-sm pt-[22px] px-4 py-[26px] text-center cursor-pointer"
        :class="getClasses(type)"
        @click="handleClick(type)"
      >
        <div
          class="font-primary font-medium text-[17px] leading-[22px] mb-5"
          :class="getTitleClasses(type)"
        >
          {{ getTitle(type) }}
        </div>

        <PersonalIcon
          v-if="type === CopyrightOwnerType.Personal"
          class="mx-auto w-[126px] h-[68px]! mb-[34px]"
          :class="getIconClasses(type)"
        />

        <OrganizationIcon
          v-else
          class="mx-auto w-[77px] mb-[26px]"
          :class="getIconClasses(type)"
        />

        <div
          class="font-secondary text-[14px] leading-[20px]"
          :class="getTextClasses(type)"
        >
          {{ getDescription(type) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { CopyrightOwnerType } from '@/shared/graphql/legacy/generated'
import PersonalIcon from '@/assets/svg/other/Personal.svg'
import OrganizationIcon from '@/assets/svg/other/Organization.svg'

const props = defineProps<{
  modelValue: CopyrightOwnerType
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', payload: CopyrightOwnerType): void
}>()

const types = [CopyrightOwnerType.Personal, CopyrightOwnerType.Organization]

const getTitle = (type: CopyrightOwnerType) => {
  if (type === CopyrightOwnerType.Personal) return 'Personal'
  if (type === CopyrightOwnerType.Organization) return 'Organization'
}

const getDescription = (type: CopyrightOwnerType) => {
  if (type === CopyrightOwnerType.Personal) {
    return 'When selected, files added will be owned by this person'
  }
  if (type === CopyrightOwnerType.Organization) {
    return 'When selected, files added will be owned by this organization'
  }
}

const getOuterClasses = (type: CopyrightOwnerType) => ({
  'border border-transparent': type !== props.modelValue,
})

const getClasses = (type: CopyrightOwnerType) => ({
  'border border-gray-800/25': type !== props.modelValue,
  'border-2 border-green-900 bg-green-700/5': type === props.modelValue,
})

const getIconClasses = (type: CopyrightOwnerType) => ({
  'stroke-gray-800 fill-gray-800 opacity-50': type !== props.modelValue,
  'stroke-green-900 fill-green-900': type === props.modelValue,
})

const getTitleClasses = (type: CopyrightOwnerType) => ({
  'text-gray-800/50': type !== props.modelValue,
  'text-green-900': type === props.modelValue,
})

const getTextClasses = (type: CopyrightOwnerType) => ({
  'text-gray-800/50': type !== props.modelValue,
  'text-green-900/70': type === props.modelValue,
})

const handleClick = (type: CopyrightOwnerType) => {
  emit('update:modelValue', type)
}
</script>
